import device from '../helpers/device'
import YTPlayer from 'yt-player'

class YouTubePlayer {
    constructor(el) { 
      this.el = el
      this.initialize()    
    }

    initialize() {
      this.bindUI()
      this.initPlayer()
      this.bindEvents()
    }

    bindUI() {
      this.ui = {}
      this.ui.$popin = document.querySelector('.js-popin')
      this.ui.$player = document.querySelector('.js-youtube-player')
      this.videoId = this.el.getAttribute('data-playerid')
      this.isPlaying = false
      this.player = null
    }

    initPlayer() {
      this.player = new YTPlayer('#youtube-player')
      this.player.load(this.videoId)
    }

    bindEvents() {
      this.el.addEventListener('click', this.onClick.bind(this))
      this.ui.$popin.addEventListener('click', this.onClose.bind(this))
    }

    onClick() {
      this.isPlaying = true
      this.player.play()
      this.el.classList.add('is-active')
      this.ui.$popin.classList.add('is-active')
      document.body.style.overflow = 'hidden'
    }

    onClose() {
      this.player.stop()
      this.isPlaying = false
      this.el.classList.remove('is-active')
      this.ui.$popin.classList.remove('is-active')
      document.body.style.overflow = 'inherit'
    }
}

export default YouTubePlayer
